export class CourseSearchCommand {
  readonly courseCategoryId: number | null;
  readonly search: string;
  readonly page: number;
  readonly perPage: number;
  readonly sortBy: string;
  readonly sortDesc: boolean;

  constructor(
    courseCategoryId: number | null,
    search: string,
    page: number,
    perPage: number,
    sortBy: string,
    sortDesc: boolean,
  ) {
    this.courseCategoryId = courseCategoryId;
    this.search = search;
    this.page = page;
    this.perPage = perPage;
    this.sortBy = sortBy;
    this.sortDesc = sortDesc;
  }
}
